import { Autocomplete, Avatar, Box, Button, Chip, CircularProgress, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Grid, IconButton, MenuItem, Radio, RadioGroup, SelectChangeEvent, TextField, Tooltip, Typography, Dialog, DialogContentText, Alert, Snackbar } from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SearchIcon from '@mui/icons-material/Search';
import React, { FC, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector, } from "../../store/hooks";
import CustomTextField from '../FormFields/CustomTextField';
import CustomSelect, { IOptions } from '../FormFields/CustomSelect';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import LoadingButton from '@mui/lab/LoadingButton';
import CustomCheckbox from '../FormFields/CustomCheckbox';
import CustomDataGrid from '../../components/DataGrid/DataGrid';

import {
  GridValueGetterParams,
  GridColDef
} from "@mui/x-data-grid";

import { ApiStatus } from "../../utils/api.types";
import { fetchAccountsByName, fetchBuyerOrSupplierByName } from '../../store/accountThunk';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { fetchBanks } from '../../store/bankStore/bankThunk';
import { fetchCurrencies } from '../../store/currencyStore/currencyThunk';
import { addCashInflowPayment } from '../../store/CashInflowStore/cashInflowThunk';
import { CashInflowPayment } from '../../utils/cashinflow.types';
import { addCashOutflowPayment } from '../../store/CashOutflowStore/cashOutflowThunk';
import { fetchInvoices, manualPayment } from '../../store/invoiceStore/invoiceThunk';
import InfoIcon from '@mui/icons-material/Info';
import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone';
import moment from 'moment';
import { Utils, VocuherTypes } from '../../utils/common-utils';
import { deepOrange, deepPurple, green, pink, blue, teal } from "@mui/material/colors";

import { AInvoice } from '../../utils/invoice.types';
import { fetchTaxRates } from '../../store/gstStore/gstThunk';
import { fetchCostCentres } from '../../store/costCentreStore/costCentreThunk';
import { toast } from 'react-toastify';

interface DialogAddPaymentFormProps {
    title: String;
    open: boolean;
    isInflow: boolean;
    onClose: (refresh: any) => void;
    preSelectedParty?: any;
}

const DialogAddPaymentForm: FC<DialogAddPaymentFormProps> = ({ onClose, open, title, isInflow, preSelectedParty }) => {

  const { status: inflowStatus } = useAppSelector(state => state.cashInflow);
  const { status: outflowStatus } = useAppSelector(state => state.cashOutflow);
  const status = isInflow ? inflowStatus : outflowStatus;
  const { invoices } = useAppSelector(state => state?.invoices);
  const { selectedAccount } = useAppSelector(state => state.auth);
  const { costCentres } = useAppSelector(state => state.costCentres);

    
    const [instrumentDisabled, setInstrumentDisabled] = useState(true);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [paymentDate, setPaymentDate] = useState<Date>(new Date(Date.now()));
    const [instrumentDate, setInstrumentDate] = useState<Date>(new Date(Date.now()));
    const [selectedToBankAccount, setSelectedToBankAccount] = useState('');
    const [selectedFromBankAccount, setSelectedFromBankAccount] = useState('');
    const [toBankAccountOptions, setToBankAccountOptions] = useState<IOptions[]>(
      []
    );
    const [fromBankAccountOptions, setFromBankAccountOptions] = useState<IOptions[]>(
      []
    );

    const [paymentMode, setPaymentMode] = useState('CASH');
    const [isCash, setIsCash] = useState(false);
    const [amountRecevied, setAmountRecevied] = useState<Number>(0);
    const [amountReceviedTemp, setAmountReceviedTemp] = useState<Number>(0);

    const [paymentModeOptions, setPaymentModeOptions] = useState<IOptions[]>([
      {label:'CASH', value:'CASH'},
      {label:'CHEQUE', value:'CHEQUE'},
      {label:'UPI', value:'UPI'},
    ]);

    const [currencyOptions, setCurrencyOptions] = useState<IOptions[]>([]);
    const [bankCurrency, setBankCurrency] = useState('');
    const [options, setOptions] = useState<any[]>(preSelectedParty ? [preSelectedParty] : []);
    const [paymentToOrFromAccount, setPaymentToOrFromAccount] = useState<any>(preSelectedParty || undefined);
    const [newOption, setNewOption] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isInvoiceLoading, setIsInvoiceLoading] = useState(false);
    const [isPartySelectionLoading, setIsPartySelectionLoading] = useState(false);
    const dispatch = useAppDispatch();
    const [closedSelect, setClosedSelect] = useState(false);

    const [startDate, setStartDate] = useState<Date>(new Date(Date.now() - 60 * 24 * 60 * 60 * 1000));
    const [endDate, setEndDate] = useState<Date>(new Date());

    const [showError, setShowError] = useState<Boolean>();
    const [showErrorMessage, setShowErrorMessage] = useState<String>('');
    const [showErrorDesc, setShowErrorDesc] = useState<String>('');

    // Enhanced error handling states
    const [excessPaymentDialog, setExcessPaymentDialog] = useState({
      open: false,
      amount: 0,
      mode: ''
    });
    const [successSnackbar, setSuccessSnackbar] = useState({
      open: false,
      message: ''
    });
    const [warningSnackbar, setWarningSnackbar] = useState({
      open: false,
      message: ''
    });
    const [errorSnackbar, setErrorSnackbar] = useState({
      open: false,
      message: ''
    });

    const [selectedAmountRange, setSelectedAmountRange] = useState('0 - 99999');
    const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState('PENDING');
    let radioChecked: string[] = [];
    const [selectedInvoice, setSelectedInvoice] = useState(radioChecked);

      const [fetchedInvoices, setFetchedInvoices] = useState<AInvoice[]>([]);
      const [selectedRows, setSelectedRows] = useState<any>([]);
      const [selectedInvoicesUpdated, setSelectedInvoicesUpdated] = useState<AInvoice[]>([]);

    const [taxRateOptions, setTaxRateOptions] = useState<any>();
    const [tdsTaxRateOptions, setTdsTaxRateOptions] = useState<any[]>([]);
    const [tcsTaxRateOptions, setTcsTaxRateOptions] = useState<IOptions[]>([]);

    const [tdsSelected, setTdsSelected] = useState({
      _id: "",
      label: "",
      rate: 0
    })

    const [selectedCostCentre, setSelectedCostCentre] = useState('');
    const [paymentType, setPaymentType] = useState<'APPLY_INVOICE' | 'ADVANCE_PAYMENT'>('APPLY_INVOICE');

    const [invoiceStatusOptions, setInvoiceStatusOptions] = useState<IOptions[]>([
      { label: 'Paid', value: 'PAID' },
      { label: 'Partially Paid', value: 'PARTIALLY_PAID' },
      { label: 'Pending', value: 'PENDING' },
      { label: 'Invoice Sent', value: 'INVOICE_SENT' }
  
    ]);

    const [amountRangeOptions, setAmountRangeOptions] = useState<IOptions[]>([
      { label: 'Below 1 Lakh', value: '0 - 99999' },
      { label: '1,00,000 - 3,00,000', value: '100000 - 300000' },
      { label: '3,00,001 - 5,00,000', value: '300001 - 500000' },
      { label: '5,00,001 - 7,00,000', value: '500001 - 700000' },
      { label: '7,00,001 - 9,00,000', value: '700001 - 900000' },
      { label: '9,00,001 & Above', value: '900001 & Above' }
    ]);


    
     // Schema to validate payment form.
    const schema = yup.object().shape({
      paymentFrom: yup.string().required(isInflow ?"Payment from is required.": "Payment to is required."),
      paymentDate: yup.string().required("Payment date is required."),
      paymentMode: yup.string().required("Payment mode is required."),
      toBankAccount: yup.string().required("To bank account is required."),
      // fromBankAccount: yup.string().required("From bank account is required."),
      currency: yup.string().required("Currency is required."),
      amount: yup.string().required("Amount is required."),
    });

    const methods = useForm<any>({ mode: 'onChange', reValidateMode:'onChange', resolver: yupResolver(schema) });
    const {control, register} = methods;

    useEffect(() => {
      let isMounted = true;
      const getTdsTcsTaxRates = async () => {
        try {
          const data = await dispatch(fetchTaxRates()).unwrap();
          if (data && data.length > 0 && isMounted) {
            setTaxRateOptions(data);
            
            const tdsRates = data.filter((items) => items.taxType === "tds");
            const tcsRates = data.filter((items) => items.taxType === "tcs");

            // Reset arrays before setting new values to prevent duplicates
            const tdsOptions = tdsRates.map((item: any) => ({
              label: `${item.taxRate}% - ${item.taxSection} ${item.taxName}`,
              value: item._id
            }));

            const tcsOptions = tcsRates.map((item: any) => ({
              label: `${item.taxRate}% - ${item.taxSection} ${item.taxName}`,
              value: item._id
            }));

            setTdsTaxRateOptions(tdsOptions);
            setTcsTaxRateOptions(tcsOptions);
          }
        } catch (error) {
          console.error('Error fetching tax rates:', error);
        }
      }
      
      if(isMounted) {
        getTdsTcsTaxRates();
      }
      
      return () => {
        isMounted = false;
      };
    }, [dispatch]);

    useEffect(() => {
      if (preSelectedParty && paymentToOrFromAccount?._id !== preSelectedParty._id) {
        console.log("Setting pre-selected party:", preSelectedParty);
        setIsPartySelectionLoading(true);
        setPaymentToOrFromAccount(preSelectedParty);
        methods.setValue(isInflow ? 'paymentFrom' : 'paymentTo', preSelectedParty._id);

        // Add pre-selected party to options array so autocomplete can display it
        setOptions([preSelectedParty]);

        // Reset invoice selection when party is pre-selected
        setFetchedInvoices([]);
        setSelectedRows([]);
        setSelectedInvoicesUpdated([]);
        setAmountRecevied(0);
        setAmountReceviedTemp(0);

        // The loading state will be cleared when invoices finish loading
        const timer = setTimeout(() => {
          setIsPartySelectionLoading(false);
        }, 500);

        return () => {
          clearTimeout(timer);
        };
      }
    }, [preSelectedParty, paymentToOrFromAccount?._id, isInflow]);

    useEffect(() => {
      const isMountedRef = { current: true };

      const fetchInvoicesIfMounted = async () => {
        if (paymentToOrFromAccount && isMountedRef.current) {
          await getInvoices(isMountedRef);
        }
      };

      fetchInvoicesIfMounted();

      return () => {
        isMountedRef.current = false;
      };
    }, [selectedInvoiceStatus, startDate, endDate, selectedAmountRange, paymentToOrFromAccount]);
  
    useEffect(() => {
      if(invoices.length > 0 ) {
        let totalOutstanding =  Number(0);
        // Make a shallow copy before sorting to avoid mutating a read-only array
        const sortedInvoices = [...invoices].sort(
          (a: any, b: any) => {
            // Ensure proper date parsing - handle both string and Date objects
            const dateA = typeof a.date === 'string' ? new Date(a.date) : new Date(a.date);
            const dateB = typeof b.date === 'string' ? new Date(b.date) : new Date(b.date);
            
            // Check for invalid dates
            if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
              console.error('Invalid date detected:', { 
                invoiceA: a.invoiceNumber, 
                dateA: a.date, 
                invoiceB: b.invoiceNumber, 
                dateB: b.date 
              });
              return 0; // Keep original order if dates are invalid
            }
            
            console.log(`Initial sorting: Invoice ${a.invoiceNumber} (${dateA.toISOString()}) vs ${b.invoiceNumber} (${dateB.toISOString()})`);
            return dateA.getTime() - dateB.getTime();
          }
        );
        console.log('Initial sorted invoice order:', sortedInvoices.map(inv => `${inv.invoiceNumber} (${new Date(inv.date).toLocaleDateString()})`));

        sortedInvoices.map((a: any) => {
          totalOutstanding += Number(a.balanceAmount);
          return a;
        });
        console.log("Calculated total outstanding after initial outstanding to be received  ===>" + totalOutstanding);
        setAmountRecevied(0);
  
        let data12 = sortedInvoices.map((row: any) => {
          return {
            ...row,
            paymentAmount: 0,
            tempBalanceAmount: row.balanceAmount,
            // isManuallyEdited: false,
            originalPaymentAmount: 0
          };
        });
        // Ensure invoices are displayed in sorted order (oldest first) in the table
        setFetchedInvoices(data12);
      } else {
        setFetchedInvoices([])
      }
      
    }, [invoices]);
    
    // useEffect(() => {
    //   console.log("useffect called ---")
    //   if (fetchedInvoices.length > 0 ) {
    //     console.log("useffect called inside if  ---")
    //     const defaultSelected = fetchedInvoices
    //       .filter((invoice) => Number(invoice.paymentAmount) > 0)
    //       .map((invoice) => { 
    //         return {
    //           _id: invoice._id, 
    //           paymentAmount: invoice.paymentAmount, 
    //           pdfTemplate: invoice.pdfTemplate, 
    //           principalAmount: invoice.principalAmount, 
    //           finalTax: invoice.finalTax, 
    //           tdsSelected: invoice.tdsSelected
    //         }
    //       });
    //     setSelectedRows(defaultSelected);
    //   }
    // }, [fetchedInvoices]); // Runs whenever invoices change
  
      const getInvoices = async (isMountedRef?: { current: boolean }) => {
        if (!paymentToOrFromAccount) return;

        // Check if component is still mounted before setting state
        if (isMountedRef && !isMountedRef.current) return;

        setIsInvoiceLoading(true);
        try {
          const { _id: id } = selectedAccount;
          let params = ""
          if (paymentToOrFromAccount) {
            params += "filter=" + paymentToOrFromAccount._id;
          }

          if (selectedInvoiceStatus) {
            params += "&status=PENDING,PARTIALLY_PAID";
          }

          params += isInflow ? `&voucherType=${VocuherTypes.GST_INVOICE}` : `&voucherType=${VocuherTypes.PURCHASE_INVOICE}`

          if (isInflow) {
            await dispatch(fetchInvoices({ accountId: id, type: 'sales', params: params }));
          } else {
            await dispatch(fetchInvoices({ accountId: id, type: 'purchase', params: params }));
          }

          // Check again after async operation
          if (isMountedRef && !isMountedRef.current) return;

          if (invoices.length > 0) {
            setSelectedInvoice([invoices[0]._id]);
          }
        } catch (error) {
          console.error('Error fetching invoices:', error);
        } finally {
          // Only update loading state if still mounted
          if (!isMountedRef || isMountedRef.current) {
            setIsInvoiceLoading(false);
          }
        }
      };
      // Define Users data grid column defs.
      const columns: GridColDef[] = [
        // {
        //   field: 'selectedInvRadio',
        //   headerName: ' ',
        //   width: 180,
        //   renderCell: (cellValues) => {
        //     return (
        //       <Radio
        //         checked={cellValues.id === selectedInvoice[0]}
        //         onChange={() => setSelectedInvoice([cellValues.id.toString()])}
        //         value={cellValues.id}
        //         name="radio-buttons"
        //       />
        //     )
        //   }
        // },
        {
          field: "date",
          headerName: 'Date',
          type: "string",
          flex: 1,
          renderCell: ({ row, value }: GridValueGetterParams) => (
            <>
            <Typography style={{ marginLeft: '-8px' }}>
                <b>{row.invoiceNumber}</b> <br/>
                { moment(row.date).format("DD MMM YYYY")}
            </Typography>
            </>
          )
        },
        {
          field: "payByDate",
          headerName: 'Due Date',
          type: "string",
          flex: 1,
          renderCell: ({ row, value }: GridValueGetterParams) => (
            <Typography style={{ marginLeft: '-8px' }}>
                { moment(row.payBydate).format("DD MMM YYYY")}
            </Typography>
          )
        },
        // {
        //   field: "invoiceNumber",
        //   headerName: 'Invoice #',
        //   type: "string",
        //   flex: 1,
        //   renderCell: ({ row, value }: GridValueGetterParams) => (
        //     <Typography
        //       sx={{ cursor: 'pointer', fontWeight: 'bold' }}
        //     >
        //       {row.invoiceNumber}
        //     </Typography>
        //   )
        // },
        {
          field: "amount",
          headerName: 'Total Amount',
          type: "string",
          flex: 1.2,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            return (
            <>
            {/* {Utils.formatNumber(parseFloat(row.amount + additionalChargesSum(row)).toFixed(2) || '0')} */}
            {Utils.formatNumber(parseFloat(row.finalAmount || (row.amount + additionalChargesSum(row)).toFixed(2)) || '0')}
              {(row.balanceAmount >= 0 || row.balanceAmount <= 0) ?
                <><br />{row.status == 'PAID' ? '' : Utils.formatNumber(Math.round(parseFloat(row.tempBalanceAmount)) || '₹ 0', true, true) + ` (Unpaid)`} </>
                : ''}
            </>);
          }
        },
        
        {
          field: "status",
          headerName: 'status',
          type: "string",
          flex: 1,
          renderCell: ({ row, value }: GridValueGetterParams) => (
            <Typography>
                { row.status }
            </Typography>
          )
        },
        {
          field: "paymentAmount",
          headerName: 'Amount Settled',
          type: "int",
          flex: 1,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            const paymentAmount = Number(row.paymentAmount || 0);
            const isSelected = selectedRows.includes(row._id);
            
            // plain divs: the grid wrapper adds margin-bottom to every MuiBox inside a cell
            return (
              <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                {/* Payment Amount - Editable when selected */}
                {isSelected ? (
                  <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <TextField
                      size="small"
                      type="number"
                      value={paymentAmount}
                      onChange={(e) => handleManualPaymentEdit(e, row)}
                      InputProps={{
                        startAdornment: '₹',
                        inputProps: { 
                          min: 0,
                          max: row.balanceAmount,
                          style: { 
                            fontSize: '0.875rem',
                            fontWeight: 600,
                            padding: '4px 8px'
                          }
                        }
                      }}
                      sx={{
                        flex: 1,
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: row.isManuallyEdited ? '#f59e0b' : '#d1d5db',
                          },
                          '&:hover fieldset': {
                            borderColor: '#059669',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#059669',
                          },
                        },
                      }}
                    />
                    {row.isManuallyEdited && (
                      <Typography
                        sx={{
                          fontSize: '0.65rem',
                          color: '#f59e0b',
                          fontWeight: 500,
                          marginLeft: 0.5
                        }}
                      >
                        ✏️
                      </Typography>
                    )}
                  </div>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <Typography 
                      sx={{ 
                        fontWeight: 600, 
                        fontSize: '0.875rem',
                        color: '#374151'
                      }}
                    >
                      {Utils.formatNumber(paymentAmount.toFixed(2))}
                    </Typography>
                    {row.isManuallyEdited && (
                      <Typography
                        sx={{
                          fontSize: '0.65rem',
                          color: '#f59e0b',
                          fontWeight: 500,
                          marginLeft: 0.5
                        }}
                      >
                        ✏️
                      </Typography>
                    )}
                  </div>
                )}
              </div>
            );
          }
        },
        {
          field: "tds",
          headerName: 'TDS Applied',
          type: "string",
          flex: 1,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            const tdsInfo = row?.tdsSelected;
            return (
              <div style={{ padding: '0 4px', width: '100%', display: 'flex', alignItems: 'center' }}>
                <Typography>
                {/* Compact TDS Information */}
                {tdsInfo?.apply && tdsInfo?.tdsSelected && (
                  <Typography 
                    sx={{ 
                      fontSize: '0.7rem',
                      color: '#059669',
                      fontWeight: 500,
                      lineHeight: 1.2
                    }}
                  >
                    TDS {tdsInfo.tdsSelected.rate}%: {Utils.formatNumber(Number(tdsInfo.totalAmount || 0).toFixed(2))}
                  </Typography>
                )}
                
                {/* No TDS Applied */}
                {(!tdsInfo?.apply || !tdsInfo?.tdsSelected) && (
                  <Typography 
                    sx={{ 
                      fontSize: '0.65rem',
                      color: '#9ca3af',
                      fontStyle: 'italic'
                    }}
                  >
                    No TDS Applied
                  </Typography>
                )}
            </Typography>
              </div>
            )

          }
        },
        {
          field: "tdsApply",
          headerName: '',
          type: "string",
          flex: 1,
          renderCell: ({ row, value }: GridValueGetterParams) => (
    
            <TdsSelect row={row} />
    
            // <CustomSelect
            //   style={{width:'100%', marginRight: 20, border: '1px Solid #079669', borderRadius: 5}}
            //   name="tdsSelected"
            //   label="Apply TDS"
            //   id={`applyTds_${Math.random()}`}
            //   variant="outlined"
            //   size='small'
            //   options={tdsTaxRateOptions}
            //   value={tdsSelected._id ?? ""}
            //   // onChange={onChangeTdsHandler}
            // />
          )
        }
      ];
    
      const additionalChargesSum = (invoice: any) => {
        let _additionalCharges;
        let initialSum = 0;
        if (invoice.additionalCharges && invoice.additionalCharges.charges && invoice.additionalCharges.charges.length > 0) {
          _additionalCharges = invoice.additionalCharges.charges.reduce((previousValue: any, currentValue: any) => previousValue + Number(currentValue.value), initialSum);
        } else {
          _additionalCharges = 0;
        }
        return _additionalCharges;
      };

      // Enhanced notification helper functions
      const showSuccess = (message: string) => {
        setSuccessSnackbar({ open: true, message });
        setShowError(false);
      };

      const showWarning = (message: string) => {
        setWarningSnackbar({ open: true, message });
      };

      const showErrorNotification = (message: string) => {
        setErrorSnackbar({ open: true, message });
        setShowError(false);
      };

      const showExcessPaymentDialog = (amount: number, mode: string) => {
        setExcessPaymentDialog({ open: true, amount, mode });
      };

      const handleExcessPaymentChoice = (choice: 'advance' | 'unassigned' | 'cancel') => {
        setExcessPaymentDialog({ open: false, amount: 0, mode: '' });
        
        if (choice === 'advance') {
          showSuccess(`Excess payment of ₹${excessPaymentDialog.amount.toFixed(2)} will be recorded as advance payment.`);
          // TODO: Implement advance payment logic
        } else if (choice === 'unassigned') {
          showSuccess(`Excess payment of ₹${excessPaymentDialog.amount.toFixed(2)} will be recorded as unassigned balance.`);
          // TODO: Implement unassigned balance logic
        }
        // Cancel just closes the dialog
      };

      const applyNewPyamentAmount = (amount: any, currentSelectedRows?: any[]) => {
        console.log("amount ===>", amount, amount.length)
        if(amount == 0 ) {
          setAmountRecevied(amountReceviedTemp)
        } else {
          setAmountRecevied(Number(Number(amount).toFixed(2)));
        }

        let remainingPayment = Number(amount) || 0;
        console.log(`Total Payment Entered: ${remainingPayment}`);

        // Determine mode: Individual Selection vs Apply to All
        const passedRows = currentSelectedRows !== undefined ? currentSelectedRows : selectedRows;
        const isApplyToAllMode = passedRows.length === 0;
        
        console.log(`Mode: ${isApplyToAllMode ? 'Apply to All Invoices' : 'Individual Selection'}`);
        console.log(`Selected Rows Count: ${passedRows.length}`);

        // 🔹 Reset all invoices before applying new payments, but preserve manually edited values
        let updatedInvoices = fetchedInvoices.map((obj: any) => ({
            ...obj,
            tempBalanceAmount: obj.isManuallyEdited ? obj.tempBalanceAmount : obj.balanceAmount, // Keep manual edits
            paymentAmount: obj.isManuallyEdited ? obj.paymentAmount : 0 // Keep manual payment amounts
        }));

        // 🔹 Determine which invoices to process
        let invoicesToProcess: any[] = [];

        if (isApplyToAllMode) {
          // Apply to ALL invoices - filter out PAID/DRAFT and sort by date (oldest first)
          invoicesToProcess = updatedInvoices
            .filter((invoice: any) => 
              invoice.status !== 'PAID' && 
              invoice.status !== 'DRAFT' && 
              invoice.status !== 'OVER_PAID' &&
              invoice.balanceAmount > 0
            )
            .sort((a: any, b: any) => {
              // Parse dates properly and sort oldest first
              const dateA = typeof a.date === 'string' ? new Date(a.date) : new Date(a.date);
              const dateB = typeof b.date === 'string' ? new Date(b.date) : new Date(b.date);
              
              // Check for invalid dates
              if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
                console.error('Invalid date in payment distribution:', { 
                  invoiceA: a.invoiceNumber, 
                  dateA: a.date, 
                  invoiceB: b.invoiceNumber, 
                  dateB: b.date 
                });
                return 0;
              }
              
              console.log(`Sorting: Invoice ${a.invoiceNumber} (${dateA.toISOString()}) vs ${b.invoiceNumber} (${dateB.toISOString()})`);
              return dateA.getTime() - dateB.getTime();
            });
          
          console.log(`Applying payment to ALL ${invoicesToProcess.length} eligible invoices`);
          console.log('Sorted invoice order:', invoicesToProcess.map(inv => `${inv.invoiceNumber} (${new Date(inv.date).toLocaleDateString()})`));
        } else {
          // Apply to SELECTED invoices only
          const selectedInvoiceIds = passedRows.map((row: any) => row._id || row);
          
          invoicesToProcess = updatedInvoices
            .filter((invoice: any) => selectedInvoiceIds.includes(invoice._id))
            .sort((a: any, b: any) => {
              // Parse dates properly and sort oldest first
              const dateA = typeof a.date === 'string' ? new Date(a.date) : new Date(a.date);
              const dateB = typeof b.date === 'string' ? new Date(b.date) : new Date(b.date);
              
              // Check for invalid dates
              if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
                console.error('Invalid date in payment distribution:', { 
                  invoiceA: a.invoiceNumber, 
                  dateA: a.date, 
                  invoiceB: b.invoiceNumber, 
                  dateB: b.date 
                });
                return 0;
              }
              
              console.log(`Sorting: Invoice ${a.invoiceNumber} (${dateA.toISOString()}) vs ${b.invoiceNumber} (${dateB.toISOString()})`);
              return dateA.getTime() - dateB.getTime();
            });

          console.log(`Applying payment to ${invoicesToProcess.length} selected invoices`);
          console.log('Sorted invoice order:', invoicesToProcess.map(inv => `${inv.invoiceNumber} (${new Date(inv.date).toLocaleDateString()})`));
        }

        // 🔹 First, subtract manually edited amounts from remaining payment
        let manuallyAllocatedAmount = 0;
        invoicesToProcess.forEach((invoice: any) => {
          if (invoice.isManuallyEdited && invoice.paymentAmount > 0) {
            manuallyAllocatedAmount += Number(invoice.paymentAmount);
          }
        });
        
        remainingPayment = Math.max(0, remainingPayment - manuallyAllocatedAmount);
        console.log(`Manually allocated amount: ${manuallyAllocatedAmount}, Remaining to distribute: ${remainingPayment}`);

        // 🔹 Apply payment to determined invoices (skip manually edited ones)
        console.log('=== PAYMENT APPLICATION ORDER ===');
        invoicesToProcess.forEach((invoice: any, index: number) => {
          if (remainingPayment <= 0) return; // Stop if no payment left
          if (invoice.isManuallyEdited) return; // Skip manually edited invoices

          const balanceAmount = invoice.tempBalanceAmount ?? invoice.balanceAmount;

          console.log(`[${index + 1}] Processing Invoice: ${invoice.invoiceNumber}, Date: ${new Date(invoice.date).toLocaleDateString()}, Balance: ${balanceAmount}, Remaining Payment: ${remainingPayment}`);

          const paymentToApply = Math.min(remainingPayment, balanceAmount);
          console.log(`    Applied: ₹${paymentToApply}, Remaining after: ₹${remainingPayment - paymentToApply}`);
          remainingPayment -= paymentToApply;

          // Update the invoice in the updatedInvoices array
          const invoiceIndex = updatedInvoices.findIndex((inv: any) => inv._id === invoice._id);
          if (invoiceIndex !== -1) {
            updatedInvoices[invoiceIndex] = {
              ...updatedInvoices[invoiceIndex],
              paymentAmount: Number(paymentToApply).toFixed(2),
              tempBalanceAmount: Number(balanceAmount - paymentToApply).toFixed(2) || 0
            };
            console.log(`    Updated invoice at index ${invoiceIndex} in updatedInvoices array`);
          }
        });
        console.log('=== END PAYMENT APPLICATION ===');

        // 🔹 Update selectedRows state if in "Apply to All" mode
        if (isApplyToAllMode) {
          const invoicesWithPayment = updatedInvoices.filter((inv: any) => Number(inv.paymentAmount) > 0);
          setSelectedRows(invoicesWithPayment.map((inv: any) => inv._id));
          setSelectedInvoicesUpdated(invoicesWithPayment);
        }

        console.log("after updated invoices =====  ", remainingPayment);

        // Enhanced Error handling with notifications
        if (invoicesToProcess.length === 0 && !isApplyToAllMode) {
          showErrorNotification("Please select one or more invoices to apply the payment.");
          return; // Exit early to prevent further processing
        } else if (invoicesToProcess.length === 0 && isApplyToAllMode) {
          showErrorNotification("No eligible invoices found. All invoices are either paid, draft, or have zero balance.");
          return; // Exit early to prevent further processing
        } else if (Number(Number(remainingPayment).toFixed(2)) > 0) {
          // Show interactive dialog for excess payment
          const modeText = isApplyToAllMode ? 'eligible' : 'selected';
          showExcessPaymentDialog(Number(remainingPayment), modeText);
        } else if (remainingPayment == 0 && invoicesToProcess.length > 0) {
          // Success case - show success notification
          const modeText = isApplyToAllMode ? 'eligible' : 'selected';
          const settledCount = invoicesToProcess.filter((inv: any) => Number(inv.paymentAmount) > 0).length;
          showSuccess(`Successfully applied payment to ${settledCount} ${modeText} invoice${settledCount > 1 ? 's' : ''}.`);
        } else if (remainingPayment < Number(amount) && invoicesToProcess.length > 0) {
          // Partial settlement case
          const appliedAmount = Number(amount) - remainingPayment;
          const modeText = isApplyToAllMode ? 'eligible' : 'selected';
          showWarning(`Partially applied ₹${appliedAmount.toFixed(2)} to ${modeText} invoices. Some invoices remain unsettled.`);
        } else {
          // Clear any previous errors
          setShowError(false);
          setShowErrorMessage('');
          setShowErrorDesc('');
        }
        // Sort the updatedInvoices to match the display order (oldest first)
        const sortedUpdatedInvoices = [...updatedInvoices].sort((a: any, b: any) => {
          const dateA = typeof a.date === 'string' ? new Date(a.date) : new Date(a.date);
          const dateB = typeof b.date === 'string' ? new Date(b.date) : new Date(b.date);
          
          // Check for invalid dates
          if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
            return 0;
          }
          
          return dateA.getTime() - dateB.getTime();
        });
        
        // Log which invoices actually have payments applied
        console.log('=== FINAL PAYMENT DISTRIBUTION ===');
        sortedUpdatedInvoices
          .filter(inv => Number(inv.paymentAmount) > 0)
          .forEach((inv, index) => {
            console.log(`[${index + 1}] Invoice: ${inv.invoiceNumber}, Date: ${new Date(inv.date).toLocaleDateString()}, Payment Applied: ₹${inv.paymentAmount}`);
          });
        console.log('=== END FINAL DISTRIBUTION ===');
        
        setFetchedInvoices(sortedUpdatedInvoices);
    
      }

      const handleManualPaymentEdit = (event: any, row: any) => {
        const newPaymentAmount = Number(event.target.value) || 0;
        const maxAmount = row.balanceAmount;

        // Validate the amount
        if (newPaymentAmount < 0) return;
        if (newPaymentAmount > maxAmount) return;

        // Update the invoice with the new payment amount
        setFetchedInvoices(current =>
          current.map(obj => {
            if (obj._id === row._id) {
              const objMaxAmount = obj.balanceAmount;

              // Clear TDS if payment is zero
              if (newPaymentAmount === 0) {
                return {
                  ...obj,
                  paymentAmount: newPaymentAmount,
                  tempBalanceAmount: Number(objMaxAmount) - Number(newPaymentAmount),
                  tdsSelected: undefined,
                  isManuallyEdited: true
                };
              }

              // Update TDS amount if TDS is applied
              if (obj.tdsSelected?.apply && obj.tdsSelected?.tdsSelected) {
                const tdsToBeAppliedOnAmount = Number(newPaymentAmount) <= Number(obj.principalAmount) ? newPaymentAmount : obj.principalAmount;
                const tdsAmount = Number((obj.tdsSelected.tdsSelected.rate * Number(tdsToBeAppliedOnAmount)) / 100);

                return {
                  ...obj,
                  paymentAmount: newPaymentAmount,
                  tempBalanceAmount: Number(objMaxAmount) - newPaymentAmount,
                  tdsSelected: {
                    ...obj.tdsSelected,
                    totalAmount: tdsAmount
                  },
                  isManuallyEdited: true
                };
              }

              return {
                ...obj,
                paymentAmount: newPaymentAmount,
                tempBalanceAmount: Number(objMaxAmount) - newPaymentAmount,
                isManuallyEdited: true
              };
            }
            console.log("Manual payment object ===> ", obj)
            return obj;
          })
        );
        
        // Recalculate total amount received based on manually edited amounts
        const totalApplied = fetchedInvoices.reduce((sum, inv) => {
          if (inv._id === row._id) {
            return sum + newPaymentAmount;
          }
          return sum + Number(inv.paymentAmount || 0);
        }, 0);
        
        setAmountRecevied(totalApplied);
        setAmountReceviedTemp(totalApplied);
      };

      const handlePaymentAmountChange = (e: any) => {
        console.log( "START ---> On Change event track 11");
        setAmountReceviedTemp(e.target.value);
        if (paymentType === 'APPLY_INVOICE') {
          // Auto-apply payment to invoices (Apply to All mode) - pass empty array to trigger auto-settlement
          applyNewPyamentAmount(e.target.value, []);
        } else {
          setAmountRecevied(Number(e.target.value) || 0);
        }
      };

      const onRowsSelectionHandler = (ids: any) => {
        console.log("=== onRowsSelectionHandler CALLED ===")
        console.log("Received IDs:", ids)
        console.log("Current selectedRows:", selectedRows)
        console.log("IDs length:", ids.length)
        
        
        setSelectedRows(ids); // Keep selectedRows as array of IDs for selectionModel
        let totalPaymentAmount = Number(0);

        // Clear TDS and manual edits for unchecked rows
        const uncheckedIds = selectedRows.filter((selectedId: any) => !ids.includes(selectedId));
        if (uncheckedIds.length > 0) {
          setFetchedInvoices(current =>
            current.map(obj => {
              if (uncheckedIds.includes(obj._id)) {
                return {
                  ...obj,
                  tdsSelected: undefined,
                  paymentAmount: 0,
                  tempBalanceAmount: obj.balanceAmount,
                  isManuallyEdited: false
                };
              }
              return obj;
            })
          );
        }

        if (ids.length > 0) {
          console.log("=== MANUAL SELECTION MODE ===");
          console.log("Selected IDs:", ids);
          console.log("fetchedInvoices:", fetchedInvoices.map(inv => ({id: inv._id, invoice: inv.invoiceNumber, paymentAmount: inv.paymentAmount, balance: inv.balanceAmount})));
          
          const selectedRowsData = ids.map((id: any) => {
            const row = fetchedInvoices.find((row) => row._id == id);
            if (!row) {
              console.warn(`Row not found for ID: ${id}`);
              return null;
            }
            
            // For manual selection, use balanceAmount (what's available to pay)
            const _payment = Number(row?.paymentAmount || 0);
            totalPaymentAmount += _payment;
            console.log(`Row: ${row?.invoiceNumber}, PaymentAmount: ${_payment}, Balance: ${row?.balanceAmount}`);
      
            return row;
          });
          
          const validSelectedRows = selectedRowsData.filter((row: any) => row !== null && row !== undefined) as AInvoice[];
          setSelectedInvoicesUpdated(validSelectedRows);
          
          console.log("=== CALCULATION SUMMARY ===");
          console.log("Manual selection - Total Payment Amount:", totalPaymentAmount);
          console.log("Selected rows count:", validSelectedRows.length);
          console.log("Setting amountRecevied to:", totalPaymentAmount);
          console.log("Current amountReceviedTemp:", amountReceviedTemp);
          
          // Update amountRecevied to total available balance from selected rows
          setAmountRecevied(totalPaymentAmount);
          
          // Apply payment logic for selected invoices with the calculated total
          // This will distribute the payment across selected invoices and update fetchedInvoices
          applyNewPyamentAmount(totalPaymentAmount, ids);
        } else {
          // When all rows are unchecked, reset to original payment amount (advance payment mode)
          setShowError(false);
          setSelectedInvoicesUpdated([]);
          setSelectedRows([])
          console.log("All rows unchecked - resetting to original payment amount as advance:", amountReceviedTemp)
          
          // Update amountRecevied back to original amount user manually entered
          setAmountRecevied(amountReceviedTemp);
          
          // Reset to original amount user wanted to add as advance - use Apply to All mode with original amount
          // applyNewPyamentAmount(amountReceviedTemp, [])
        }

      };

      const TdsSelect = React.memo((row: any) => {
        const paymentAmount = Number(row.row?.paymentAmount || 0);
        const isDisabled = paymentAmount <= 0;

        return (
          <CustomSelect
            name="tdsSelected"
            id={`tesSelected_${row.row?._id}`}
            label={`Apply Tds`}
            style={{ flex: 1, marginRight: '5px' }}
            variant="outlined"
            size="small"
            options={tdsTaxRateOptions}
            onChange={(event: SelectChangeEvent<any>) => {
              onChangeTdsHandler(event, row);
            }}
            value={row?.tdsSelected?.tdsSelected?._id || ''}
            disabled={isDisabled}
          />
        );
      });

        const onChangeTdsHandler = (event: any, row: any) => {
          console.log("======= Called onChangeTdsHandler ====", event.target.value);
          console.log("======= Called onChangeTdsHandler ====", event.target.name);
          console.log("======= Called onChangeTdsHandler ====", event.target.label);

          const selectedRowId = row.row._id;
          console.log("selectedRowId === ", selectedRowId)

          // Find the current row to check paymentAmount
          const currentRow = fetchedInvoices.find(obj => obj._id === selectedRowId);
          const paymentAmount = Number(currentRow?.paymentAmount || 0);

          // Validate paymentAmount > 0 before applying TDS
          if (paymentAmount <= 0) {
            showErrorNotification("TDS can only be applied when payment amount is greater than 0");
            return;
          }

          const d = taxRateOptions.filter(function (item: any) {
            return item._id == event.target.value;
          });

          let updatedInvoices = fetchedInvoices.map((obj: any) => 
            obj._id == selectedRowId ? { ...obj, tdsSelected: {} } : obj
          );
          updatedInvoices = updatedInvoices.map((obj: any) => {
            if(obj._id == selectedRowId ) {

              let tdsToBeAppliedOnAmount = 0;
              if(Number(obj.paymentAmount) <= Number(obj.principalAmount) ) {
                tdsToBeAppliedOnAmount = obj.paymentAmount
              } else {
                tdsToBeAppliedOnAmount = obj.principalAmount
              }

              var totalTaxableAmount = Number(Number(obj.principalAmount) + additionalChargesSum(obj));
              var tdsAmount = Number((d[0].taxRate * Number(tdsToBeAppliedOnAmount)) / 100);
              const tdsData = {
                apply: true,
                totalAmount: tdsAmount,
                taxableAmount: obj.principalAmount,
                displayType: 0,
                tdsSelected: {
                  _id: event.target.value,
                  label: d[0].taxName,
                  rate: d[0].taxRate,
                  taxSection: d[0].taxSection
                }
              }
              console.log(tdsData);
              return { ...obj, tdsSelected: tdsData };
            }
            return obj;
          });
          setFetchedInvoices(updatedInvoices)
        }

    
    
    const onChangeHandler = (event: any, value: any) => {
      setNewOption('');
      setIsPartySelectionLoading(true);
      setPaymentToOrFromAccount(value);
      methods.setValue(isInflow ? 'paymentFrom' : 'paymentTo', value?._id);

      // Reset invoice selection when party changes
      setFetchedInvoices([]);
      setSelectedRows([]);
      setSelectedInvoicesUpdated([]);
      setAmountRecevied(0);
      setAmountReceviedTemp(0);

      // Clear party bank accounts when party changes
      if (isInflow) {
        setFromBankAccountOptions([]);
        setSelectedFromBankAccount('');
        methods.setValue('fromBankAccount', '');
      } else {
        setToBankAccountOptions([]);
        setSelectedToBankAccount('');
        methods.setValue('toBankAccount', '');
      }

      setTimeout(() => {
        setIsPartySelectionLoading(false);
      }, 500);
    }

    const onInputChangeHandler = async (event: React.SyntheticEvent, value: string) => {
      setPaymentToOrFromAccount('');
      setNewOption('');
      const title = isInflow? 'buyer': 'supplier';
      const _querystring = `name=${value}&searchFor=${title?.toLocaleLowerCase()}`
      await dispatch(fetchBuyerOrSupplierByName(_querystring)).unwrap().then((data) => {
        if(data) {
          setOptions(data.accounts);
        }
      });
    };
    
  //Handle date range picker
  const handleDateChange = (newValue: Date | null, name: string | undefined) => {
    if (newValue) {
      if (name === 'paymentDate') {
        setPaymentDate(newValue);
      } else if (name === 'instrumentDate') {
        setInstrumentDate(newValue);
      } else if (name === 'startDate') {
        setStartDate(newValue);
      } else if (name === 'endDate') {
        setEndDate(newValue);
      }
      if (name) {
        methods.setValue(name, newValue);
      }
    }
  };

  const onSubmit = async (e: any) => {

    const data = methods.getValues();
    console.log(data);

    if(!paymentToOrFromAccount) {
      toast.error("Please select party")
      return
    }
    if(Number(amountRecevied) <= 0 ) {
      toast.error("Please enter amount")
      return
    }

    console.log(paymentToOrFromAccount);
    console.log(paymentToOrFromAccount._id);

    // For advance payment, no invoices needed
    let filteredInvoices: any[] = [];

    if (paymentType === 'APPLY_INVOICE') {
      // Get the latest invoice data from fetchedInvoices for selected rows
      const selectedInvoiceIds = selectedRows;
      const currentSelectedInvoices = fetchedInvoices.filter(inv =>
        selectedInvoiceIds.includes(inv._id) && Number(inv.paymentAmount) > 0
      );

      console.log("Current selected invoices with payment amounts:", currentSelectedInvoices.map(inv => ({
        invoiceNumber: inv.invoiceNumber,
        paymentAmount: inv.paymentAmount,
        isManuallyEdited: inv.isManuallyEdited
      })));

      // Filter only required fields from the current state
      filteredInvoices = currentSelectedInvoices.map(invoice => ({
        _id: invoice._id,
        invoiceNumber: invoice.invoiceNumber,
        paymentAmount: invoice.paymentAmount,
        pdfTemplate: invoice.pdfTemplate,
        principalAmount: invoice.principalAmount,
        finalTax: invoice.finalTax,
        tdsSelected: invoice.tdsSelected
      }));
    }

    let addPaymentReqObj: CashInflowPayment = {
      "account": selectedAccount._id,
      "paymentDate": data.paymentDate,
      "bankClearingDate": Date.now(),
      "entryDate": Date.now(),
      "amount": amountRecevied,
      "currency": "62a4b0ceb628fb10ac97ce0e", // data.currency,
      "toBankAccount": selectedToBankAccount,
      "paymentMode": paymentMode.toUpperCase(),
      "instrument": paymentMode.toUpperCase(),
      "instrumentId": data.instrumentId,
      "instrumentDate": new Date(paymentDate).getTime(),
      "fromBankAccount": data.fromBankAccount || "",
      "ref1": data.ref1,
      "ref2": data.ref2,
      "ref3": data.ref3,
      "remark": data.remark,
      "appliedFlag": false,
      // "invoices": (selectedRows && selectedRows.length > 0) ? selectedRows : []
      "invoices": (filteredInvoices && filteredInvoices.length > 0) ? filteredInvoices : [],
      "costCentre": selectedCostCentre || undefined
    };
    
    if (isInflow) {
      addPaymentReqObj["paymentFrom"] = paymentToOrFromAccount._id;
      addPaymentReqObj["bankDepositDate"] = Date.now();
      addPaymentReqObj["paymentStatus"] = "RECEIVED"
      console.log(addPaymentReqObj);
      await dispatch(addCashInflowPayment(addPaymentReqObj)).unwrap();
    } else {
      addPaymentReqObj["paymentTo"] = paymentToOrFromAccount._id;
      addPaymentReqObj["bankDebitDate"] = Date.now();
      addPaymentReqObj["paymentStatus"] = "PAID"
      console.log(addPaymentReqObj);
      await dispatch(addCashOutflowPayment(addPaymentReqObj)).unwrap();
    }
    methods.reset();
    onClose(true);
  };

  useEffect(() => {
    // Use bank accounts already populated in the party object from searchAccount API
    // This ensures we only show bank accounts that belong to the selected party
    if (paymentToOrFromAccount?._id) {
      // For Payment In: fromBankAccount = party's bank (where payment comes from)
      // For Payment Out: toBankAccount = party's bank (where payment goes to)
      let applyToOrFromOptions = isInflow ? setFromBankAccountOptions: setToBankAccountOptions;
      let applySelectedToOrFrom = isInflow ? setSelectedFromBankAccount: setSelectedToBankAccount;

      // Get bank accounts from the party object (already populated by searchAccount API)
      const partyBankAccounts = paymentToOrFromAccount.bankAccounts || [];

      // Map to dropdown options - only if bank accounts exist
      const partyBanks = partyBankAccounts
        .filter((bank: any) => bank && bank._id) // Only include valid bank objects
        .map((bank: any) => ({
          label: `${bank.accountName || 'Account'}-${bank.bankName || 'Bank'}`,
          value: bank._id
        }));

      console.log(`Setting bank accounts for party ${paymentToOrFromAccount.legalName || paymentToOrFromAccount.name}:`, partyBanks);

      applyToOrFromOptions(partyBanks);

      if (partyBanks.length > 0 && partyBanks[0]?.value) {
        let formField = isInflow? 'fromBankAccount': 'toBankAccount';
        methods.setValue(formField, partyBanks[0].value);
        applySelectedToOrFrom(partyBanks[0].value);
      } else {
        // Clear selection if no banks available for this party
        let formField = isInflow? 'fromBankAccount': 'toBankAccount';
        methods.setValue(formField, '');
        applySelectedToOrFrom('');
        console.log(`No bank accounts found for party ${paymentToOrFromAccount.legalName || paymentToOrFromAccount.name}`);
      }
    }
  },[paymentToOrFromAccount, isInflow]);

  useEffect(() => {
    let isMounted = true;

    const getBankDetails = async() => {
      if (selectedAccount?._id && isMounted) {
        const toBanks: any = await dispatch(fetchBanks(selectedAccount._id));
        if (!isMounted) return;

        // For Payment In: toBankAccount = my company's bank (where payment deposits)
        // For Payment Out: fromBankAccount = my company's bank (where payment comes from)
        let applyToOrFromOptions = isInflow ? setToBankAccountOptions: setFromBankAccountOptions;
        let applySelectedToOrFrom = isInflow ? setSelectedToBankAccount: setSelectedFromBankAccount;

        // Filter only bank accounts (not countries, employees, etc.)
        const companyBanks = (toBanks.payload.banks || []).map((c: any) => {
          return { label: c.accountName+'-'+c.bankName, value: c._id }
        });

        applyToOrFromOptions(companyBanks);

        if (companyBanks.length > 0 && companyBanks[0]?.value) {
          let formField = isInflow? 'toBankAccount': 'fromBankAccount';
          methods.setValue(formField, companyBanks[0].value);
          applySelectedToOrFrom(companyBanks[0].value);
        } else {
          // Clear selection if no banks available
          let formField = isInflow? 'toBankAccount': 'fromBankAccount';
          methods.setValue(formField, '');
          applySelectedToOrFrom('');
        }
      }
    };

    const getCurrencies = async () => {
      if (!currencyOptions.length && isMounted) {
        const data: any = await dispatch(fetchCurrencies());
        if (!isMounted) return;

        setCurrencyOptions(data.payload.map((c: any) => {
          return { label: c.code, value: c._id }
        }));
      }
    };

    const getCostCentres = async () => {
      if (isMounted) {
        await dispatch(fetchCostCentres({ activeOnly: true, useForPayments: true }));
      }
    };

    getCurrencies();
    getCostCentres();
    getBankDetails();
    const setInitialData = () => {
        // methods.setValue('paymentFrom', data.paymentFrom);
        methods.setValue('paymentDate', paymentDate);
        // methods.setValue('paymentMode', data.paymentMode);
        // methods.setValue('instrument', data.instrument);
        methods.setValue('instrumentDate', instrumentDate);
        // methods.setValue('toBankAccount', data.toBankAccount);
        // methods.setValue('currency', data.currency);
        // methods.setValue('amount', data.amount);
      };
      setInitialData();

    return () => {
      isMounted = false;
    };
  }, [dispatch, selectedAccount._id, isInflow]);

  useEffect(() => {
    // Reset formSubmitted and bank accounts when dialog opens
    if (open) {
      setFormSubmitted(false);
      // Reset bank account options to ensure clean state
      // Company bank accounts will be fetched by the other useEffect
      if (!preSelectedParty) {
        // Only reset party bank accounts if no party is pre-selected
        if (isInflow) {
          setFromBankAccountOptions([]);
          setSelectedFromBankAccount('');
        } else {
          setToBankAccountOptions([]);
          setSelectedToBankAccount('');
        }
      }
    }
  }, [open, preSelectedParty, isInflow]);

  useEffect(() => {
    if (status === ApiStatus.SUCCESS && formSubmitted) {
      onClose(false);
      setFormSubmitted(false);
    }
  }, [status, formSubmitted, onClose]);

  // Function to get a random color from an array
  const getRandomColor = () => {
    const colors = [pink[500], green[500], blue[500], deepOrange[500], deepPurple[500], teal[500]];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const handleRenderOption = (e: any, b: any, c: any) => {
    // console.log('b.counterPartyOfAccount: ', b.counterPartyOfAccount, b.name);
    return <div {...e} className='auto-item' key={Math.random()} style={{alignItems: 'center'}}>
      <div className='img-wrapper' style={{marginLeft: 10}}>
        <Avatar
          alt={b.name}
          imgProps={{ referrerPolicy: "no-referrer" }}
          src={b.logo}
          sx={{bgcolor: getRandomColor() }}
          style={{
            width: "35px",
            height: "35px",
            objectFit: "contain",
          }}
          sizes={"xs"}
        >{b.name.toString().substr(0,1).toUpperCase()}</Avatar>
      </div>
      <div style={{marginLeft: 10}}>
        <b style={{'marginRight': '5px'}}>

          <p style={{fontSize:13}}>
            {b.legalName} 
            {b.isAgent && 
              <Chip 
                size='small' 
                style={{
                  height:18, float: 'right', borderRadius:7,color:'#49a563',backgroundColor:'#edf6ef',
                  fontSize:11,marginTop:2,marginRight:3, marginLeft:3
                }} 
                label={<>Agent</>}
              />
            }
            {b.isVendor && 
              <Chip 
                size='small' 
                style={{
                  height:18, float: 'right', borderRadius:7,color:'#49a563',backgroundColor:'#edf6ef',
                  fontSize:11,marginTop:2,marginRight:3, marginLeft:3
                }} 
                label={<>Vendor</>}
              />
            }
            {b.isClient && 
              <Chip 
                size='small' 
                style={{
                  height:18, float: 'right', borderRadius:7,color:'#49a563',backgroundColor:'#edf6ef',
                  fontSize:11,marginTop:2,marginRight:3, marginLeft:3
                }} 
                label={<>Customer</>}
              />
            }
          </p>
        </b> 
        {!b.counterPartyOfAccount && <Tooltip title="Verified account"><InfoIcon style={{ fontSize: '12px', color: '#aaa' }}></InfoIcon></Tooltip>}
      </div>
    </div>
  };

  const onCloseHandler = () => {
    setClosedSelect(true);
  };

  const onOpenHandler = () => {
    setClosedSelect(false);
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let val = (event.target as HTMLInputElement).value;
    if (val == 'Cash') {
      setIsCash(true);
    } else {
      setIsCash(false);
    }
    setPaymentMode((event.target as HTMLInputElement).value);
  };

  return (
    <div className="" style={{width: "100%", maxWidth: "1200px"}}>
      <FormProvider {...methods}>
        <Box
          sx={{ display: "flex", flexDirection: "column", height: "100vh", padding: "2px 0 2px 2px" }}
          component="form"
          noValidate>
          <DialogTitle>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", minHeight: '40px' }}>
              <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.125rem' }}>
                {isInflow? 'Add New Payment In': 'Add New Payment Out'}
              </Typography>
              {(isPartySelectionLoading || isInvoiceLoading) && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CircularProgress size={16} sx={{ color: '#059669' }} />
                  <Typography variant="body2" sx={{ color: '#6b7280', fontSize: '0.8rem' }}>
                    {isPartySelectionLoading ? 'Loading party details...' : 'Loading invoices...'}
                  </Typography>
                </Box>
              )}
            </Box>
          </DialogTitle>

          <DialogContent sx={{ padding: '16px 24px' }}>
            <Grid container spacing={2}>
              {/* Row 1: Party Selection and Amount */}
              {preSelectedParty ? (
                // Show readonly party information when preSelectedParty is provided
                <Grid item xs={12} mt={1}>
                  <Box sx={{ borderRadius: '8px', border: '2px solid #e9ecf1', backgroundColor: '#fff' }}>
                    <Grid container>
                      <Grid item xs={12} sx={{ p: 1.5, pl: 2, pt: 1.5, pb: 1.5, bgcolor: '#e9ecf1', borderTopLeftRadius: 6, borderTopRightRadius: 6 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                          <IconButton
                            style={{ color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: -5, marginRight: 15, marginLeft: -5 }}
                            size='small'>
                            <PeopleAltTwoToneIcon style={{ fontSize: 20 }} />
                          </IconButton>
                          {paymentToOrFromAccount?.legalName || paymentToOrFromAccount?.name || 'Unknown Party'}
                        </Typography>
                        <Box sx={{ marginLeft: '45px' }}>
                          {paymentToOrFromAccount?.whatsAppNumber && (
                            <Chip
                              size='small'
                              style={{height:28, borderRadius:7, color:'#767676', backgroundColor:'#fff', fontSize:13, marginRight: 10, marginBottom: 10}}
                              label={`Phone: ${paymentToOrFromAccount.whatsAppNumber}`}
                            />
                          )}
                          {paymentToOrFromAccount?.email && (
                            <Chip
                              size='small'
                              style={{height:28, borderRadius:7, color:'#767676', backgroundColor:'#fff', fontSize:13, marginRight: 10, marginBottom: 10}}
                              label={paymentToOrFromAccount.email}
                            />
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              ) : (
                // Show Autocomplete for manual party selection when no preSelectedParty
                <Grid item xs={12} mt={1.5}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                      <Controller
                        name={isInflow? 'paymentFrom': 'paymentTo'}
                        control={control}
                        render={() => (
                        <Autocomplete
                            id={isInflow? 'paymentFrom': 'paymentTo'}
                            freeSolo
                            value={paymentToOrFromAccount || null}
                            onChange={onChangeHandler}
                            onInputChange={onInputChangeHandler}
                            renderOption={handleRenderOption}
                            onClose={onCloseHandler}
                            onOpen={onOpenHandler}
                            options={options}
                            isOptionEqualToValue={(option, value) => {
                              if (!option || !value) return option === value;
                              return option._id === value._id;
                            }}
                            getOptionLabel={option => {
                              if (typeof option === 'object' && option !== null) {
                                console.log("getOptionLabel - object fields:", Object.keys(option));
                                return option?.legalName || option?.name || "";
                              }
                              console.log("getOptionLabel - not object:", option);
                              return String(option || "");
                            }}
                            renderInput={(params) => <CustomTextField {...params} value={paymentToOrFromAccount ?? ""} name={isInflow ? 'paymentFrom' : 'paymentTo'} label={isInflow? 'Payment From *': 'Payment To *'} size="small" />}
                            style={{ width: '100%' }}
                          />
                        )}/>
                    </Grid>
                    <Grid item xs={3}>
                      <CustomTextField
                        label="Enter Amount *"
                        name="amount"
                        type="Number"
                        variant="outlined"
                        size='small'
                        value={amountRecevied}
                        onChange={(e:any) => handlePaymentAmountChange(e)}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={3} sx={{ mt: '2px' }}>
                      <TextField
                        select
                        name="paymentType"
                        label="Payment Type"
                        id="paymentType"
                        variant="outlined"
                        size='small'
                        fullWidth
                        value={paymentType}
                        onChange={(e: any) => {
                          setPaymentType(e.target.value);
                          if (e.target.value === 'ADVANCE_PAYMENT') {
                            setSelectedRows([]);
                            setSelectedInvoicesUpdated([]);
                          }
                        }}
                      >
                        <MenuItem value="APPLY_INVOICE">Apply Invoice</MenuItem>
                        <MenuItem value="ADVANCE_PAYMENT">Advance Payment</MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {/* Amount & Payment Type for preSelectedParty */}
              {preSelectedParty && (
              <>
              <Grid item xs={6} mt={1.5}>
                <CustomTextField
                  label="Enter Amount *"
                  name="amount"
                  type="Number"
                  variant="outlined"
                  size='small'
                  value={amountRecevied}
                  onChange={(e:any) => handlePaymentAmountChange(e)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} mt={1.5}>
                <TextField
                  select
                  name="paymentType"
                  label="Payment Type"
                  id="paymentType"
                  variant="outlined"
                  size='small'
                  fullWidth
                  value={paymentType}
                  onChange={(e: any) => {
                    setPaymentType(e.target.value);
                    if (e.target.value === 'ADVANCE_PAYMENT') {
                      setSelectedRows([]);
                      setSelectedInvoicesUpdated([]);
                    }
                  }}
                >
                  <MenuItem value="APPLY_INVOICE">Apply Invoice</MenuItem>
                  <MenuItem value="ADVANCE_PAYMENT">Advance Payment</MenuItem>
                </TextField>
              </Grid>
              </>
              )}

              {/* Row 2: Payment Date, Bank Accounts */}
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid item xs={4}>
                  <DesktopDatePicker
                      label="Payment Date"
                      inputFormat="dd/MM/yyyy"
                      maxDate={moment().add(1).toDate()}
                      value={paymentDate}
                      onChange={(value) => { handleDateChange(value, 'paymentDate') }}
                      renderInput={(params) => <TextField {...params} name={'paymentDate'} required variant="outlined" size='small' fullWidth />}
                    />
                </Grid>
                <Grid item xs={4}>
                  <CustomSelect
                    sx={{
                      width: '100%',
                      '& .MuiInputLabel-root': {
                        transform: 'translate(14px, 9px) scale(1)',
                        '&.MuiInputLabel-shrink': {
                          transform: 'translate(14px, -9px) scale(0.75)'
                        }
                      },
                      '& .MuiSelect-select': {
                        padding: '8.5px 14px',
                        display: 'flex',
                        alignItems: 'center'
                      }
                    }}
                    name="fromBankAccount"
                    label="From Bank Account"
                    id="fromBankAccount-1"
                    variant="outlined"
                    size='small'
                    options={fromBankAccountOptions}
                    value={selectedFromBankAccount ?? ""}
                    onChange={(event: SelectChangeEvent<any>) => {
                      methods.setValue('fromBankAccount', event.target.value);
                      setSelectedFromBankAccount(event.target.value);
                  }}/>
                </Grid>
                <Grid item xs={4}>
                  <CustomSelect
                    disabled={isCash}
                    sx={{
                      width: '100%',
                      '& .MuiInputLabel-root': {
                        transform: 'translate(14px, 9px) scale(1)',
                        '&.MuiInputLabel-shrink': {
                          transform: 'translate(14px, -9px) scale(0.75)'
                        }
                      },
                      '& .MuiSelect-select': {
                        padding: '8.5px 14px',
                        display: 'flex',
                        alignItems: 'center'
                      }
                    }}
                    name="depositTo"
                    label="Deposit To"
                    id="depositTo"
                    variant="outlined"
                    size='small'
                    options={toBankAccountOptions}
                    value={selectedToBankAccount ?? ""}
                    onChange={(event: SelectChangeEvent<any>) => {
                      methods.setValue('toBankAccount', event.target.value);
                      setSelectedToBankAccount(event.target.value);
                  }} />
                </Grid>
              </LocalizationProvider>

              {/* Cost Centre Selection - Only show if cost centres exist */}
              {costCentres && costCentres.length > 0 && (
                <Grid item xs={12}>
                  <CustomSelect
                    name="costCentre"
                    id="costCentre"
                    label="Cost Centre (Optional)"
                    size="small"
                    fullWidth
                    options={costCentres.map((cc: any) => ({
                      label: cc.alias ? `${cc.name} (${cc.alias})` : cc.name,
                      value: cc._id
                    }))}
                    value={selectedCostCentre}
                    onChange={(e: any) => setSelectedCostCentre(e.target.value)}
                  />
                </Grid>
              )}

              {/* Row 3: Payment Method Radio Buttons */}
              <Grid item xs={12}>
                <RadioGroup
                  {...methods.register("instrumentType")}
                  row
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="CASH"
                  name="instrumentType"
                  style={{ margin: '0px 0' }}
                  onChange={(handleRadioChange)}>
                  <FormControlLabel style={{marginRight: 20}} value="CASH" control={<Radio size="small" />} label="Cash" />
                  <FormControlLabel style={{marginRight: 20}} value="CHEQUE" control={<Radio size="small" />} label="Cheque" />
                  <FormControlLabel style={{marginRight: 20}} value="CARD" control={<Radio size="small" />} label="Card" />
                  <FormControlLabel style={{marginRight: 20}} value="UPI" control={<Radio size="small" />} label="UPI" />
                  <FormControlLabel style={{marginRight: 20}} value="NETBANKING" control={<Radio size="small" />} label="Netbanking" />
                </RadioGroup>
              </Grid>
              
              {/* Row 4: Reference Fields and Remark */}
              <Grid item xs={3}>
                <CustomTextField
                  disabled={isCash}
                  variant="outlined"
                  size='small'
                  label="Cheque/UPI/Trxn ID"
                  name="instrumentId" />
              </Grid>
              <Grid item xs={3}>
                <CustomTextField
                  variant="outlined"
                  size='small'
                  label="Ref Note 1"
                  name="ref1" />
              </Grid>
              <Grid item xs={3}>
                <CustomTextField
                  variant="outlined"
                  size='small'
                  label="Ref Note 2"
                  name="ref2" />
              </Grid>
              <Grid item xs={3}>
                <CustomTextField 
                  label="Remark" 
                  name="remark" 
                  variant="outlined" 
                  size='small'
                />
              </Grid>

              {/* <Grid item xs={12}>
                <Divider sx={{ my: 1 }} />
              </Grid> */}
              {paymentType === 'APPLY_INVOICE' && (<>
              <Grid item xs={12} display="flex" justifyContent="flex-end" >
                <Grid container justifyContent="left">
                  <Grid item xs={12}>
                    <Typography style={{fontSize: 16}}> Check the boxes to apply payments for multiple invoices. </Typography>
                    <Typography style={{fontSize: 14, color: '#6b7280', marginTop: 4}}>
                      Tip: Click on selected invoices to manually edit payment amounts. Manually edited amounts will not be changed by auto-distribution.
                    </Typography>
                    <Typography> {selectedInvoicesUpdated.length > 0 && `Selected Invoices:` } {selectedInvoicesUpdated.map(invoice => `${invoice.invoiceNumber} , `)} </Typography>
                  </Grid>
                </Grid>
              </Grid>
              {showError &&
                <Grid item xs={12} md={12} sm={12} lg={12}>
                  <Typography variant="h5" color='error'>{showErrorMessage}</Typography>
                  <Typography variant="h6" color='error'>{showErrorDesc}</Typography>

                </Grid>
              }
              <div style={{
                height: Math.min(Math.max(300, fetchedInvoices.length * 80 + 80), 500),
                width: '100%',
                paddingTop: '10px'
              }}>
                {!paymentToOrFromAccount ? (
                  <Box 
                    sx={{ 
                      height: '100%', 
                      display: 'flex', 
                      flexDirection: 'column',
                      alignItems: 'center', 
                      justifyContent: 'center',
                      background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 50%, #f7fee7 100%)',
                      border: '2px dashed #a7f3d0',
                      borderRadius: 3,
                      position: 'relative',
                      overflow: 'hidden',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'radial-gradient(circle at 20% 80%, rgba(16, 185, 129, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(5, 150, 105, 0.08) 0%, transparent 50%)',
                        pointerEvents: 'none',
                      }
                    }}
                  >
                    {/* Animated Icon Container */}
                    <Box 
                      sx={{ 
                        width: 80, 
                        height: 80, 
                        borderRadius: '50%', 
                        background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 3,
                        position: 'relative',
                        boxShadow: '0 8px 32px rgba(5, 150, 105, 0.3)',
                        animation: 'pulse 2s ease-in-out infinite',
                        '@keyframes pulse': {
                          '0%': { transform: 'scale(1)', boxShadow: '0 8px 32px rgba(5, 150, 105, 0.3)' },
                          '50%': { transform: 'scale(1.05)', boxShadow: '0 12px 40px rgba(5, 150, 105, 0.4)' },
                          '100%': { transform: 'scale(1)', boxShadow: '0 8px 32px rgba(5, 150, 105, 0.3)' }
                        }
                      }}
                    >
                      <SearchIcon sx={{ fontSize: 40, color: '#ffffff' }} />
                    </Box>
                    
                    {/* Main Text */}
                    <Typography 
                      variant="h6" 
                      sx={{ 
                        color: '#065f46', 
                        fontWeight: 600,
                        marginBottom: 1,
                        textAlign: 'center'
                      }}
                    >
                      Select a Party
                    </Typography>
                    
                    {/* Description */}
                    <Typography 
                      sx={{ 
                        color: '#6b7280', 
                        fontSize: '0.875rem',
                        textAlign: 'center',
                        maxWidth: '280px',
                        lineHeight: 1.5
                      }}
                    >
                      Choose a {isInflow ? 'Buyer' : 'Supplier'} from the dropdown above to view their pending invoices and process payments
                    </Typography>
                    
                    {/* Decorative Elements */}
                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 20,
                        right: 20,
                        opacity: 0.1,
                        transform: 'rotate(15deg)'
                      }}
                    >
                      <ReceiptIcon sx={{ fontSize: 60, color: '#059669' }} />
                    </Box>
                    
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 20,
                        left: 20,
                        opacity: 0.08,
                        transform: 'rotate(-15deg)'
                      }}
                    >
                      <ReceiptIcon sx={{ fontSize: 40, color: '#059669' }} />
                    </Box>
                  </Box>
                ) : (
                  <CustomDataGrid
                    isRowSelectable={(params: any) =>
                        params.row.status != 'DRAFT' && params.row.status != 'PAID' && params.row.status != 'OVER_PAID'}
                    onSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
                    selectionModel={selectedRows}
                    checkboxSelection={true}
                    disableSelectionOnClick
                    columns={columns}
                    rows={fetchedInvoices}
                    getRowId={(row) => row._id}
                    rowHeight={150}
                    sx={{
                      '& .MuiDataGrid-cell': {
                        whiteSpace: 'normal !important',
                        wordWrap: 'break-word',
                        overflow: 'visible !important',
                        textOverflow: 'unset !important',
                        lineHeight: 'normal',
                        padding: '8px',
                        display: 'flex',
                        alignItems: 'center'
                      },
                      // '& .MuiDataGrid-row': {
                      //   maxHeight: 'none !important',
                      //   '&:hover': {
                      //     backgroundColor: 'rgba(5, 150, 105, 0.04)'
                      //   }
                      // },
                      '& .MuiDataGrid-cellContent': {
                        whiteSpace: 'normal',
                        overflow: 'visible',
                        textOverflow: 'unset'
                      }
                    }}
                    loading={isInvoiceLoading || status === ApiStatus.LOADING} />
                )}
              </div>
              </>)}

            </Grid>
          </DialogContent>

          <DialogActions sx={{ height: "40px", mb: 2 }}>
            <Grid container gap='0' sx={{ mr: '32px', pt: '10px' }}>
              <Grid item xs={12} md={12} sm={12} lg={12} display="flex" justifyContent="flex-end" >
                <Button variant='outlined'
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    methods.reset();
                    onClose(false);
                  }}>Cancel</Button>
                <LoadingButton
                  type="button"
                  // onClick={methods.handleSubmit(onSubmit)}
                  onClick={onSubmit}
                  variant="contained"
                  loading={status === ApiStatus.LOADING}>
                  Record Payment {isInflow ? 'In' : 'Out'}
                </LoadingButton>
              </Grid>
            </Grid>
          </DialogActions>
        </Box>
      </FormProvider>

      {/* Enhanced Error Handling Components */}
      
      {/* Excess Payment Confirmation Dialog */}
      <Dialog 
        open={excessPaymentDialog.open} 
        onClose={() => handleExcessPaymentChoice('cancel')}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                backgroundColor: '#fef3c7',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Typography sx={{ fontSize: '20px' }}>⚠️</Typography>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, color: '#92400e' }}>
                Excess Payment Detected
              </Typography>
              <Typography variant="body2" sx={{ color: '#6b7280' }}>
                ₹{excessPaymentDialog.amount.toFixed(2)} remains after settling all {excessPaymentDialog.mode} invoices
              </Typography>
            </Box>
          </Box>
        </DialogTitle>
        
        <DialogContent>
          <DialogContentText sx={{ mb: 2, color: '#374151' }}>
            All {excessPaymentDialog.mode} invoices have been fully settled, but there's still an excess amount. 
            How would you like to handle this remaining amount?
          </DialogContentText>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ p: 2, border: '1px solid #e5e7eb', borderRadius: 2, backgroundColor: '#f9fafb' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#059669', mb: 0.5 }}>
                💰 Record as Advance Payment
              </Typography>
              <Typography variant="body2" sx={{ color: '#6b7280' }}>
                The excess amount will be credited to the customer's account for future invoices
              </Typography>
            </Box>
            
            <Box sx={{ p: 2, border: '1px solid #e5e7eb', borderRadius: 2, backgroundColor: '#f9fafb' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#7c3aed', mb: 0.5 }}>
                📝 Record as Unassigned Balance
              </Typography>
              <Typography variant="body2" sx={{ color: '#6b7280' }}>
                The excess amount will be kept as unassigned balance for manual allocation
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ p: 3, gap: 1 }}>
          <Button 
            onClick={() => handleExcessPaymentChoice('cancel')}
            variant="outlined"
            sx={{ minWidth: '100px' }}
          >
            Cancel
          </Button>
          <Button 
            onClick={() => handleExcessPaymentChoice('unassigned')}
            variant="outlined"
            sx={{ 
              minWidth: '140px',
              borderColor: '#7c3aed',
              color: '#7c3aed',
              '&:hover': {
                backgroundColor: '#f3f4f6'
              }
            }}
          >
            Unassigned Balance
          </Button>
          <Button 
            onClick={() => handleExcessPaymentChoice('advance')}
            variant="contained"
            sx={{ 
              minWidth: '140px',
              backgroundColor: '#059669',
              '&:hover': {
                backgroundColor: '#047857'
              }
            }}
          >
            Advance Payment
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success Snackbar */}
      <Snackbar
        open={successSnackbar.open}
        autoHideDuration={6000}
        onClose={() => setSuccessSnackbar({ open: false, message: '' })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setSuccessSnackbar({ open: false, message: '' })} 
          severity="success" 
          sx={{ width: '100%' }}
        >
          {successSnackbar.message}
        </Alert>
      </Snackbar>

      {/* Warning Snackbar */}
      <Snackbar
        open={warningSnackbar.open}
        autoHideDuration={8000}
        onClose={() => setWarningSnackbar({ open: false, message: '' })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setWarningSnackbar({ open: false, message: '' })} 
          severity="warning" 
          sx={{ width: '100%' }}
        >
          {warningSnackbar.message}
        </Alert>
      </Snackbar>

      {/* Error Snackbar */}
      <Snackbar
        open={errorSnackbar.open}
        autoHideDuration={6000}
        onClose={() => setErrorSnackbar({ open: false, message: '' })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setErrorSnackbar({ open: false, message: '' })} 
          severity="error" 
          sx={{ width: '100%' }}
        >
          {errorSnackbar.message}
        </Alert>
      </Snackbar>

    </div>
  );
};

export default DialogAddPaymentForm;